import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static values = { id: String, componentAction: String };

    connect() {
        let id = this.idValue;
        let replacementElement = document.getElementById(`brand-${id}`);

        if (replacementElement) {
            const targetElement = replacementElement.querySelector('[data-remote-modal-target]');

            if (targetElement) {
                targetElement.textContent = this.componentActionValue;
            }
        }
    }

    hideNextBtn() {
        document.getElementById('next-block').classList.add("is-hidden");
    }

    btnloader() {
        document.getElementById('like-dislike-block')?.classList.add("hidden");
        document.querySelector('.loader').classList.remove("is-hidden");
    }
}
